<template>
  <div>
    <div class="d-flex align-center justify-start">
      <v-btn
        v-if="backTo"
        icon
        color="primary"
        :to="{name: backTo, params: backParams, query: getListQueryParams}"
        exact
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <span class="h5Header secondary500">{{ title }}</span>
    </div>
    <div>
      <bread-crumbs
        :back-params="backParams"
        :back-route="backTo"
      />
    </div>
  </div>
</template>

<script>
import BreadCrumbs from 'Arch/template/BreadCrumbs.vue';
import LocalSessionMixin from '../mixins/LocalSessionMixin';

export default {
  name: 'PageTitle',
  components: { BreadCrumbs },
  mixins: [LocalSessionMixin],
  props: {
    title: {
      type: String,
      required: true,
    },
    backTo: {
      type: String,
      default: '',
    },
    backParams: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    getListQueryParams() {
      const query = this.getSessionItem('listQuery');
      return query;
    },
  },
};
</script>
